export default "__VITE_ASSET__C0m$zVeO__"